import {getCurrentLayout} from "../../appLayout";
import {getPartIdFromLixilCategoryName} from "../lookLixilCategories";

/**
 * @param shopCategoryId {string}
 * @returns {object} featureGroup
 */
export const getFeatureGroupFromUrl = (shopCategoryId) => {
  if (!shopCategoryId) {
    return null
  }
  const layout = getCurrentLayout();
  return layout.getFeatureGroupByPartId(shopCategoryId)
    || layout.getFeatureGroupByPartId(getPartIdFromLixilCategoryName(shopCategoryId));
}

/**
 * @param shopCategoryId {string}
 * @param skuId {string}
 * @param withSharedFeatureName {boolean}
 * @returns {featureInterface} feature
 */
export const getFeatureFromUrl = (shopCategoryId, skuId, withSharedFeatureName = false) => {
  if (!shopCategoryId || !skuId) {
    return null
  }
  const layout = getCurrentLayout();
  const featureGroup = getFeatureGroupFromUrl(shopCategoryId);
  return layout.getFeatureBySku(skuId, featureGroup ? featureGroup.partId : "", true, withSharedFeatureName)
}
